import React from 'react'
import styled from 'styled-components'
import guillemet1 from '../../../assets/guillemet-1.svg'

const QuoteBoxContainerWithQuote = styled.div`
  padding-top: 24px;
  display: flex;
  flex: calc(50% - 24px);
`

const QuoteBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 32 * 2px - 17px);
  gap: 8px;
  padding: 24px;
  background-color: #fff;

  @media (min-width: 422px) {
    max-width: 340px;
  }

  @media (min-width: 768px) {
    max-width: 446px;
  }

  h1 {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #253163;
    margin: 0;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #000;
    margin: 0;
    padding: 0;
  }

  :before {
    content: url(${guillemet1});
    position: absolute;
    margin-top: -42px;
    width: 33px;
    height: 28px;
  }
`

export const QuoteBox = ({ title, text }) => (
  <QuoteBoxContainerWithQuote>
    <QuoteBoxContainer>
      <h1>{title}</h1>
      <p>{text}</p>
    </QuoteBoxContainer>
  </QuoteBoxContainerWithQuote>
)
